// extracted by mini-css-extract-plugin
export default {"ExtrasComponentContainer":"Extras_ExtrasComponentContainer__ydZva","ExtraComponentPrice":"Extras_ExtraComponentPrice__AitMu"};